import { Outlet } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import NotificationCenter from '../components/NotificationCenter';
import UserMenu from '../components/UserMenu';
import BalanceDisplay from '../components/BalanceDisplay';

export default function MainLayout() {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <header className="h-[60px] surface-elevated flex items-center justify-between px-6 shrink-0 z-10">
          <div className="w-32" />
          <div className="flex items-center gap-2">
            <BalanceDisplay />
            <button
              onClick={() => navigate('/create')}
              className="flex items-center gap-2 px-5 py-2.5 gradient-brand text-white rounded-btn text-[13px] font-semibold hover-lift shadow-sm shadow-brand/20"
            >
              <Plus size={15} strokeWidth={2.5} /> 创建舞蹈
            </button>
            <NotificationCenter />
            <UserMenu />
          </div>
        </header>
        <main className="flex-1 overflow-auto bg-bg-main">
          <div className="page-enter">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
